import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from 'formik';
import { Box, Button, TextField, Divider, Typography } from "@mui/material";
import { CustomNumberInput } from '../../components';
import { FromArticuloSkeleton } from '../../components/skeletons';
import ArticleData from "../Table/Mobile/ArticleData";
// enums not needed directly here
import OrderLinesEditor from './OrderLinesEditor';
import { FechaFormateada } from "../Table/helpers";

const formSchema = Yup.object().shape({
  lines: Yup.array().of(
    Yup.object({
      note: Yup.string().trim().required('Nota requerida'),
      requestedQty: Yup.number().min(0, '>=0')
    })
  ),
  quantity: Yup.number()
    .when('lines', {
      is: (lines) => !lines || lines.length === 0,
      then: (schema) => schema.required('Campo Requerido').moreThan(0),
      otherwise: (schema) => schema.min(0)
    }),
  description: Yup.string()
    .when('lines', {
      is: (lines) => !lines || lines.length === 0,
      then: (schema) => schema.required('Campo Requerido'),
      otherwise: (schema) => schema.notRequired()
    })
});

const initialValues = {
  description: "",
  quantity: 0,
  lines: []
}

const FormPedidos = ({ saving = false, onClose, article, onSubmit }) => {
  const { article: { name, images }, prices, article_id, created_at } = article;

  const handleSubmitForm = async (data) => {
    // Build lines payload if present, fallback to single aggregate line built from quantity & description
    let payload = { ...data };
    if (payload.lines && payload.lines.length > 0) {
      // Remove empty lines
      payload.lines = payload.lines.filter(l => l.note && l.note.trim());
      // If quantity field is zero but we have lines, sum requestedQty
      if (!payload.quantity || payload.quantity === 0) {
        payload.quantity = payload.lines.reduce((sum, l) => sum + (Number(l.requestedQty) || 0), 0);
      }
      // Also build a synthetic description from lines for backward compatibility
      payload.description = payload.lines.map(l => `${l.requestedQty || 1} ${l.note}`).join(', ');
    } else {
      // create a default single line from quantity + description for easier later parsing
      if (payload.quantity > 0 && payload.description) {
        payload.lines = [{ id: Math.random().toString(36).slice(2), note: payload.description, requestedQty: payload.quantity, obtainedQty: 0, done: false }];
      }
    }
    onSubmit && onSubmit(payload)
  }
  
  const { handleChange, handleSubmit, setFieldValue, values, errors, isValid } = useFormik({
    initialValues,
    onSubmit: handleSubmitForm,
    validationSchema: formSchema,
    validateOnMount: true
  })

  const { description, quantity, lines } = values
  const [useLines, setUseLines] = useState(true);

  return <Box display='flex' flexDirection='column' padding={0} margin={0}>
  <Box sx={{background: 'red'}} display='flex' padding={0} margin={0} width='100%'>
    <ArticleData 
      key={article_id} 
      data={{
        id: article_id,
        name: name,
        images: images,
        description: article.article.description,
        date: FechaFormateada(created_at),
        price: prices?.list_price,
        quantity: article.quantity,
        to: article.to
      }}
      readonly
      imagesOnly
    />
  </Box>
  <Box
    component="form"
    onSubmit={handleSubmit}
    display='flex'
    flexDirection='column'
    sx={{padding: 3}}
  >
    <Divider><strong>Nuevo Pedido</strong></Divider>
    {saving ? <FromArticuloSkeleton /> :
      <Box>
        {/* <Box display='flex' flexDirection='row' justifyContent="space-between" marginY={1}>
          <strong>Nuevo Pedido</strong>
        </Box > */}
        
        {!useLines && <Box display='flex' flexDirection='row' gap={2} marginY={2}>
          <CustomNumberInput
            id="quantity"
            label='Cantidad'
            minimo={0}
            maximo={200}
            value={quantity}
            onChange={(event, newValue) => {
              event.preventDefault();
              setFieldValue('quantity', newValue);
            }}
            incrementsButtons
          />
        </Box>}
        {!useLines && <TextField
          id="description"
          label="Descripción"
          type="text"
          variant="outlined"
          fullWidth
          error={errors.description}
          helperText={errors.description}
          value={description}
          onChange={handleChange}
          multiline
          maxRows={5}
          sx={{ marginY: 1 }}
        />}
        {useLines && <Box mt={2}>
          <Typography variant='subtitle2' gutterBottom>Variantes / Detalle</Typography>
          <OrderLinesEditor
            lines={lines}
            onChange={(lns)=>setFieldValue('lines', lns)}
          />
          {lines && lines.length === 0 && <Typography variant='caption' color='text.secondary'>Agregá líneas con el botón +, ejemplo: 2 negras, 1 gris.</Typography>}
        </Box>}
        <Box mt={2}>
          <Button size='small' onClick={()=> setUseLines(u=>!u)}>
            {useLines ? 'Usar campo descripción único' : 'Usar líneas detalladas'}
          </Button>
        </Box>
        <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
          
        </Box>
      </Box>}
    <Box sx={{ mt: 5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <Button type="button" variant="outlined" onClick={onClose}>Cancelar</Button>
      <Button type="submit" variant="outlined" disabled={!isValid}>Guardar</Button>
    </Box>
  </Box>
</Box>
}

export default FormPedidos;